module.exports = __webpack_public_path__ + "images/thumbs-down-fill327431cb46319b3d315a1331f911c0ab.svg";